import { createContext } from 'react';
import { colors, types, } from './constants';
export const defaultContext = {
    disabled: undefined,
    folderColor: colors.light,
    folderType: types.standard,
    titleSize: 'medium',
};
export const AccordionContext = createContext(defaultContext);
